import { useEffect, useState } from "react";

const useScreenSize = () => {
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  function getSize() {
    setScreenHeight(window.innerHeight);
    setScreenWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', getSize);
  });

  return { screenHeight, screenWidth };
};

export default useScreenSize;